<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <h3>{{$route.meta.title}}</h3>

      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/customer-task' }">客户任务管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="parentPage">客户项目管理({{customer.name}})</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel :show-header="false">
      <el-form ref="form"
               :model="dataModel"
               :rules="formRules"
               label-width="160px"
               @submit.native.prevent="onSubmit()">

        <el-collapse v-model="activeNames">
          <el-collapse-item title="项目基本信息" name="1">

            <el-form-item prop="name"
                          label="项目名称:">
              <el-col :span="inputWith">
                <el-input v-model="dataModel.name"
                          maxlength="50"
                          clearable></el-input>
              </el-col>
            </el-form-item>

            <el-form-item prop="number"
                          label="项目编号:">
              <el-col :span="inputWith">
                <el-input :disabled="disableEditProjectNumber"
                          v-model="dataModel.number"
                          maxlength="50"
                          clearable></el-input>
              </el-col>
            </el-form-item>

            <el-form-item prop="execute_rate"
                          label="执行频次:">
              <el-col :span="inputWith">
                <el-input v-model="dataModel.execute_rate"
                          maxlength="50"
                          clearable></el-input>
              </el-col>
            </el-form-item>

            <el-form-item label="BD"
                          prop="bd">
              <el-col :span="inputWith">
                <remote-select
                  class="width-max"
                  clearable
                  id-key="id"
                  keyword-key="name"
                  label-key="name"
                  value-key="id"
                  placeholder="请输入管理员名称搜索"
                  v-model="dataModel.bd"
                  :query-request="(_)=>getPlatformUsersIndex(Object.assign(_, {usertype: [1, 2, 5], status: 1}))"
                  :find-request="getRemoteSelectAdminUsers">
                </remote-select>
              </el-col>
            </el-form-item>

            <el-form-item label="BO"
                          prop="bu">
              <el-col :span="inputWith">
                <remote-select
                  class="width-max"
                  clearable
                  id-key="id"
                  keyword-key="name"
                  label-key="name"
                  value-key="id"
                  placeholder="请输入管理员名称搜索"
                  v-model="dataModel.bu"
                  :query-request="(_)=>getPlatformUsersIndex(Object.assign(_, {usertype: [1, 2, 5], status: 1}))"
                  :find-request="getRemoteSelectAdminUsers">
                </remote-select>
              </el-col>
            </el-form-item>

            <el-form-item label="申请人"
                          prop="creator">
              <span>{{ initiator_name }}</span>
            </el-form-item>

            <el-form-item label="项目组长"
                          prop="project_master">
              <el-col :span="inputWith">
                <el-input v-model="dataModel.project_master"
                          maxlength="10"
                          clearable></el-input>
              </el-col>
            </el-form-item>

            <el-form-item label="项目等级"
                          prop="project_level">
              <el-col :span="inputWith">
              <el-select class="width-max"
                         v-model="dataModel.project_level"
                         placeholder="请选择">
                <el-option
                  v-for="item in opts.projectLevel"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
              </el-col>
            </el-form-item>

            <el-form-item prop="project_category"
                          label="项目分类:">
              <el-col :span="inputWith">
                <el-input v-model="dataModel.project_category"
                          maxlength="50"
                          clearable></el-input>
              </el-col>
            </el-form-item>

            <el-form-item prop="target_complete_rate"
                          label="目标完成率:">
              <el-col :span="inputWith"
                      style="width: 260px">
                <el-input v-model.number="dataModel.target_complete_rate"
                          maxlength="20"
                          clearable>
                  <template slot="append">%</template>
                </el-input>
              </el-col>
            </el-form-item>

            <el-form-item prop="target_market_num"
                          label="目标门店数:">
              <el-col :span="inputWith"
                      style="width: 260px">
                <el-input v-model.number="dataModel.target_market_num"
                          maxlength="20"
                          clearable>
                </el-input>
              </el-col>
            </el-form-item>

            <el-form-item prop="starttime"
                          label="开始时间:">
              <el-date-picker
                value-format="yyyy-MM-dd HH:mm:ss"
                v-model="dataModel.starttime"
                type="datetime"
                align="center">
              </el-date-picker>
            </el-form-item>

            <el-form-item prop="endtime"
                          label="结束时间:">
              <el-date-picker
                value-format="yyyy-MM-dd HH:mm:ss"
                v-model="dataModel.endtime"
                type="datetime"
                align="center">
              </el-date-picker>
            </el-form-item>

            <el-form-item label="任务发布通知:"
                          prop="enable_release_notice">
              <el-col :span="inputWith">
                <el-switch v-model="dataModel.enable_release_notice"
                           active-value="1"
                           inactive-value="0"
                           active-text="开启"
                           inactive-text="关闭"
                           active-color="#13ce66"
                           inactive-color="#ff4949">
                </el-switch>
              </el-col>
            </el-form-item>

            <el-form-item label="APP首页是否展示任务包:"
                          class="app-task-package-display-form-item"
                          prop="app_task_package_display"
                          required>
              <el-radio-group v-model="dataModel.app_task_package_display"
                              :disabled="isDisabled()">
                <el-radio v-for="item in taskPackageOpts.displayFormMaps"
                          :key="item.value"
                          :label="item.value">{{ item.label }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item v-if="isDisplayEnabled(dataModel.app_task_package_display)"
                          label="首页任务包名称:"
                          prop="app_task_package_title"
                          required>
              <el-col :span="inputWith">
                <el-input
                  v-model="dataModel.app_task_package_title"
                  :disabled="isDisabled()"
                  maxlength="255"
                  clearable
                  placeholder="请输入"
                />
              </el-col>
            </el-form-item>
            <el-form-item v-if="isDisplayPartial(dataModel.app_task_package_display)"
                          label="白名单标签/标签组:"
                          prop="app_task_package_whitelist_tags"
                          required>
              <el-col :span="inputWith">
                <remote-select
                  class="width-max"
                  clearable
                  multiple
                  id-key="id"
                  label-key="tagname"
                  value-key="id"
                  placeholder="请输入标签或标签组关键字"
                  :disabled="isDisabled()"
                  v-model="dataModel.app_task_package_whitelist_tags"
                  :query-request="getUserTagTable"
                  :find-request="getUserTagDetail"
                />
              </el-col>
            </el-form-item>
            <!-- 首页任务包（project_task_package）配置见上方 -->
          </el-collapse-item>
          <el-collapse-item title="财务信息" name="2">

            <el-form-item label="服务类型"
                          prop="distribute_type">
              <el-col :span="inputWith">
                <el-select class="width-max"
                           :disabled="isDisabled()"
                           v-model="dataModel.distribute_type"
                           placeholder="请选择">
                  <el-option
                    v-for="item in distributeType"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
                <div style="font-size: 13px;line-height:20px;margin-top: 5px;">
                  <el-alert
                    v-if="distributeTypeTip !== ''"
                    :title="distributeTypeTip"
                    type="info"
                    :closable="false" />
                </div>
              </el-col>

            </el-form-item>

            <el-form-item label="审核归属"
                          prop="review_group">
              <el-col :span="inputWith">
              <el-select class="width-max"
                         :disabled="isDisabled()"
                         v-model="dataModel.review_group"
                         placeholder="请选择">
                <el-option
                  v-for="item in opts.reviewGroup"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-col>
            </el-form-item>

            <!--预算类状态审批通过后是无法在此修改的-->
            <el-form-item v-for="type in frontCostTypes" :key="type" :prop="type"
                          label="前端预算:">
                <template slot="label">
                  前端预算
                  <el-tooltip class="item" effect="dark" content="发布与结算爱零工、爱数智任务" placement="bottom">
                    <i class="el-icon-question"></i>
                  </el-tooltip>
                </template>
              <el-col :span="inputWith"
                      style="width: 260px">
                <el-input v-model="dataModel.predict_frontend_cost"
                          :disabled="isDisabled() || (dataModel.distribute_type === 5 && dataModel.predict_others_cost > 0)"
                          maxlength="20"
                          clearable>
                  <template slot="append">元</template>
                </el-input>
              </el-col>
            </el-form-item>

            <el-form-item prop="predict_label_cost"
                          label="标注预算:">
                <template slot="label">
                  标注预算
                  <el-tooltip class="item" effect="dark" content="发布与结算标注任务" placement="bottom">
                    <i class="el-icon-question"></i>
                  </el-tooltip>
                </template>
              <el-col :span="inputWith"
                      style="width: 260px">
                <el-input v-model="dataModel.predict_label_cost"
                          :disabled="isDisabled()"
                          maxlength="20"
                          clearable>
                  <template slot="append">元</template>
                </el-input>
              </el-col>
            </el-form-item>

            <el-form-item v-for="type in backCostTypes" :key="type" :prop="type"
                          label="后端预算:">
                <template slot="label">
                  后端预算
                  <el-tooltip class="item" effect="dark" content="实习生费用结算" placement="bottom">
                    <i class="el-icon-question"></i>
                  </el-tooltip>
                </template>
              <el-col :span="inputWith"
                      style="width: 260px">
                <el-input v-model="dataModel.predict_backend_cost"
                          :disabled="isDisabled()"
                          maxlength="20"
                          clearable>
                  <template slot="append">元</template>
                </el-input>
              </el-col>
            </el-form-item>

            <el-form-item v-for="type in otherCostTypes" :key="type" :prop="type"
                          label="其他预算:">
                <template slot="label">
                  其他预算
                  <el-tooltip class="item" effect="dark" content="用于付款申请" placement="bottom">
                    <i class="el-icon-question"></i>
                  </el-tooltip>
                </template>
              <el-col :span="inputWith"
                      style="width: 260px">
                <el-input v-model="dataModel.predict_others_cost"
                          :disabled="isDisabled() || (dataModel.distribute_type === 5 && dataModel.predict_frontend_cost > 0)"
                          maxlength="20"
                          clearable>
                  <template slot="append">元</template>
                </el-input>
              </el-col>
            </el-form-item>


            <el-form-item prop="total_cost"
                          label="项目总预算:">
              <el-col :span="inputWith"
                      style="width: 260px">
                <el-input v-model="totalCost"
                          :disabled="true"
                          maxlength="20"
                          clearable>
                  <template slot="append">元</template>
                </el-input>
              </el-col>
            </el-form-item>


            <el-form-item prop="ticket_predict"
                          label="预估开票金额(未税):">
              <el-col :span="inputWith"
                      style="width: 260px">
                <el-input v-model="dataModel.ticket_predict"
                          :disabled="isTicketPredictDisabled()"
                          maxlength="20"
                          clearable>
                  <template slot="append">元</template>
                </el-input>
              </el-col>
            </el-form-item>


            <el-form-item prop="gross_rate_predict"
                          label="预估毛利率:">
              <el-col :span="inputWith"
                      style="width: 260px">
                <el-input v-model.number="grossRatePredit"
                          :disabled="true"
                          maxlength="20"
                          clearable>
                  <template slot="append">%</template>
                </el-input>
              </el-col>
            </el-form-item>


            <el-form-item prop="executive_budget"
                          label="预估执行成本:">
              <el-col :span="inputWith">
                <el-input v-model="dataModel.executive_budget"
                          :disabled="isDisabled()"
                          maxlength="20"
                          clearable></el-input>
              </el-col>
            </el-form-item>

          </el-collapse-item>
          <el-collapse-item title="合规情况" name="3">
           <el-form-item label="项目初次执行"
                          prop="is_first_execute">
              <el-radio-group v-model="dataModel.is_first_execute">
                <el-radio :label="1"
                          border>是
                </el-radio>
                <el-radio :label="0"
                          border>否
                </el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item label="商务流程完备"
                          prop="business_process_completed">
              <el-radio-group v-model="dataModel.business_process_completed">
                <el-radio :label="1"
                          border>是
                </el-radio>
                <el-radio :label="0"
                          border>否
                </el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item :prop="annual_cooperation_scale"
                          :key="annual_cooperation_scale"
                          v-for="annual_cooperation_scale in annualScales"
                          label="年度合作规模:">
              <el-col :span="inputWith"
                      style="width: 260px">
                <el-input v-model="dataModel.annual_cooperation_scale"
                          maxlength="20"
                          clearable>
                  <template slot="append">万元</template>
                </el-input>
              </el-col>
            </el-form-item>

            <el-form-item :prop="annual_cooperation_times"
                          :key="annual_cooperation_times"
                          v-for="annual_cooperation_times in annualTimes"
                          label="全年合作次数:">
              <el-col :span="inputWith"
                      style="width: 260px">
                <el-input v-model="dataModel.annual_cooperation_times"
                          maxlength="20"
                          clearable>
                  <template slot="append">次</template>
                </el-input>
              </el-col>
            </el-form-item>

            <el-form-item prop="contract_no"
                          label="所属合同编号:"
                          key="contract_no"
                          v-if="dataModel.business_process_completed">
              <el-col :span="inputWith">
                <el-input v-model="dataModel.contract_no"
                          clearable></el-input>
              </el-col>
            </el-form-item>

            <el-form-item prop="type"
                          label="项目类型:">
              <el-col :span="inputWith"
                      style="width: 260px">
                <el-select v-model="dataModel.type"
                           :disabled="isDisabled()"
                           clearable>
                  <el-option v-for="item in opts.type"
                             :key="item.value"
                             :label="item.label"
                             :value="item.value">
                  </el-option>
                </el-select>
              </el-col>
            </el-form-item>

            <el-form-item v-for="type in detailTypes" :key="type" :prop="type"
                          label="项目备注:">
              <el-col :span="inputWith">
                <el-input v-model="dataModel.detail"
                          clearable></el-input>
              </el-col>
            </el-form-item>

            <el-form-item label="BO审核"
                          prop="bu_approver">
              <el-col :span="inputWith">
                <remote-select
                  class="width-max"
                  clearable
                  id-key="id"
                  keyword-key="name"
                  label-key="name"
                  value-key="id"
                  placeholder="请输入管理员名称搜索"
                  v-model="dataModel.bu_approver"
                  :query-request="(_)=>getPlatformUsersIndex(Object.assign(_, {usertype: [1, 2, 5], status: 1}))"
                  :find-request="getRemoteSelectAdminUsers">
                </remote-select>
              </el-col>
            </el-form-item>


            <el-form-item label="一级审核"
                          prop="first_approver">
              <el-col :span="inputWith">
                <remote-select
                  class="width-max"
                  clearable
                  id-key="id"
                  keyword-key="name"
                  label-key="name"
                  value-key="id"
                  placeholder="请输入管理员名称搜索"
                  v-model="dataModel.first_approver"
                  :query-request="(_)=>getPlatformUsersIndex(Object.assign(_, {usertype: [1, 2, 5], status: 1}))"
                  :find-request="getRemoteSelectAdminUsers">
                </remote-select>
              </el-col>
            </el-form-item>

            <el-form-item label="二级审核"
                          prop="second_approver">
              <el-col :span="inputWith">
                <remote-select
                  class="width-max"
                  clearable
                  id-key="id"
                  keyword-key="name"
                  label-key="name"
                  value-key="id"
                  placeholder="请输入管理员名称搜索"
                  v-model="dataModel.second_approver"
                  :query-request="(_)=>getPlatformUsersIndex(Object.assign(_, {usertype: [1, 2, 5], status: 1}))"
                  :find-request="getRemoteSelectAdminUsers">
                </remote-select>
              </el-col>
            </el-form-item>

            <el-form-item label="财务审核"
                          prop="finance_approver">
              <el-col :span="inputWith">
                <remote-select
                  class="width-max"
                  clearable
                  id-key="id"
                  keyword-key="name"
                  label-key="name"
                  value-key="id"
                  placeholder="请输入管理员名称搜索"
                  v-model="dataModel.finance_approver"
                  :query-request="(_)=>getPlatformUsersIndex(Object.assign(_, {usertype: [1, 2, 5], status: 1}))"
                  :find-request="getRemoteSelectAdminUsers">
                </remote-select>
              </el-col>
            </el-form-item>

            <el-form-item label="收件人"
                          prop="receiver">
              <el-col :span="inputWith">
                <remote-select
                  class="width-max"
                  clearable
                  multiple
                  :multiple-limit=multipleLimit
                  id-key="id"
                  keyword-key="name"
                  label-key="name"
                  value-key="id"
                  placeholder="请输入管理员名称搜索"
                  v-model="dataModel.receiver"
                  :query-request="(_)=>getPlatformUsersIndex(Object.assign(_, {usertype: [1, 2, 5], status: 1}))"
                  :find-request="getRemoteSelectAdminUsers">
                </remote-select>
              </el-col>
            </el-form-item>

            <el-form-item label="附件" prop="attached_file">
              <el-upload
                class="upload-demo"
                action=""
                multiple
                :auto-upload="false"
                :on-change="function (res, file) {return onChangeFile(res, file) }"
                :before-remove="function (res, file) {return beforeRemove(res, file) }"
                :limit="limit"
                :on-exceed="handleExceed"
                :file-list="fileList"
                accept=".jpg, .jpeg, .xlsx, .pdf, .eml"
                ref="upload"
              >
                <el-button size="small"
                           type="primary">点击上传
                </el-button>
                <div slot="tip"
                     class="el-upload__tip">只能上传jpg,xlsx,pdf,eml文件
                </div>
              </el-upload>
            </el-form-item>

            <el-form-item label="">
              <template>
                <div class="view-navbar">
                  <ul class="clear-both">
                    <li v-for="(item, index) in dataModel.attached_file" :key="index">
                      <el-tooltip class="item" effect="dark" :content="item.name" placement="bottom">
                        <img v-if="item.type === 'pic'" style="width: 100px; height: 100px" :src="item.url" @click="onViewImage">
                        <i v-if="item.type !== 'pic'"
                           class="sj-icon-pdf"
                           style=" font-size:100px; margin-top: 50px"
                           @click="onGetPdfFile(item, index)"></i>
                      </el-tooltip>
                    </li>
                  </ul>

                </div>
              </template>
            </el-form-item>

          </el-collapse-item>
        </el-collapse>



        <el-row class="form-panel">
          <el-button type="primary"
                     size="mini"
                     native-type="submit">保存
          </el-button>
          <el-button type="primary"
                     size="mini"
                     v-if="[statusEnum.OPEN, statusEnum.REJECTED, 0].includes(dataModel.status * 1)"
                     @click="onSubmit(true)">保存并提交
          </el-button>
          <el-button size="mini"
                     @click="$router.push(parentPage)">
            <span>取消</span>
          </el-button>
        </el-row>
      </el-form>

    </layout-panel>
  </div>
</template>


<script>
import { formRules } from '../customer-project.rules'
import 'viewerjs/dist/viewer.css'
import Viewer from 'viewerjs'
import {
  consts as taskPackageConsts,
  opts as taskPackageOpts,
  isDisplayEnabled,
  isDisplayPartial,
} from '@views/project-task-package/project-task-package.constants'

export default {
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.onLoad()
      vm.setPreviousTable(from)
    })
  },
  computed: {
    ...Vuex.mapState({
      user: state => state.login.user,
      opts: state => state.customerProject,
      statusEnum: state => state.customerProjectcost.statusEnum,
    }),
    totalCost: {
      get () {
        let cost = parseFloat(this.dataModel.predict_frontend_cost || 0) +
        parseFloat(this.dataModel.predict_label_cost || 0) +
        parseFloat(this.dataModel.predict_backend_cost || 0) +
        parseFloat(this.dataModel.predict_others_cost || 0)
        return cost.toFixed(2)
      }
    },
    frontCostTypes () {
      if ([10, 13, 14, 15, 16, 17, 18, 19].includes(this.dataModel.distribute_type)) {
        return ['predict_frontend_cost']
      }
      if ((this.dataModel.distribute_type === 5)) {
        if (this.dataModel.predict_others_cost > 0) {
          return ['predict_frontend_cost_no_force']
        } else {
          return ['predict_frontend_cost']
        }
      }
      return ['predict_frontend_cost_no_force']
    },
    backCostTypes () {
      if ([7, 8, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23].includes(this.dataModel.distribute_type)) {
        return ['predict_backend_cost']
      }
      return ['predict_backend_cost_no_force']
    },
    otherCostTypes () {
      if ([7, 8, 9, 10, 11, 12, 20, 21, 22, 23, 24].includes(this.dataModel.distribute_type)) {
        return ['predict_others_cost']
      }
      if ((this.dataModel.distribute_type === 5)) {
        if (this.dataModel.predict_frontend_cost > 0) {
          return ['predict_others_cost_no_force']
        } else {
          return ['predict_others_cost']
        }
      }
      return ['predict_others_cost_no_force']
    },
    detailTypes () {
      if (this.grossRatePredit < 35) {
        return ['detail']
      }
      return ['detail_not_req']
    },
    annualScales () {
      if (parseInt(this.dataModel.project_level) === 4) {
        return ['annual_cooperation_scale']
      }
      return ['annual_cooperation_scale_no_force']
    },
    annualTimes () {
      if (parseInt(this.dataModel.project_level) === 4) {
        return ['annual_cooperation_times']
      }
      return ['annual_cooperation_times_no_force']
    },
    // 毛利率=（预估开票-预估成本）/预估开票
    grossRatePredit: {
      get () {
        let rate = _.round(((parseFloat(this.dataModel.ticket_predict) - parseFloat(this.totalCost)) / parseFloat(this.dataModel.ticket_predict) * 100), 2)
        this.dataModel.gross_rate_predict = rate
        return rate
      },
    },
    distributeTypeTip () {
      const tips = {
        5: '不涉及外部供应商',
        7: '需由百度或其他合作伙伴提供技术支持的技术类项目',
        9: '涉及外部供应商，原AJX模式',
        10: '类拣货、招聘等',
        11: '非业务立项使用',
        12: '非主营的业务，非众包服务、非数字服务、非综合服务等业务',
        13: '涉及前端零工，信息收集',
        14: '类供应链健康度',
        15: '类问卷调查',
        17: '类谈判、卖进',
        19: '类产品真伪、水货',
        21: '需由百度或其他合作伙伴提供技术支持的技术类项目',
      }
      return tips[this.dataModel.distribute_type] || ''
    },
    disableEditProjectNumber () {
      return this.status === '30' && this.$route.meta.isUpdate
    },
  },
  watch: {
    'dataModel.predict_frontend_cost' () {
      if (!this.id) {
        this.dataModel.executive_budget = _.round(this.dataModel.predict_frontend_cost * 0.05, 2)
      }
    },
    'dataModel.app_task_package_display' (val) {
      if (!isDisplayPartial(val)) {
        this.dataModel.app_task_package_whitelist_tags = []
      }
    },
  },
  data () {
    formRules.endtime.push({validator: this.endtimeValidator, trigger: 'blur'})
    formRules.number.push({validator: this.projectNumberFormatValidator, trigger: 'blur'})
    formRules.app_task_package_title = [{validator: this.appTaskPackageTitleValidator, trigger: 'blur'}]
    formRules.app_task_package_whitelist_tags = [{validator: this.appTaskPackageWhitelistValidator, trigger: 'change'}]
    return {
      taskPackageOpts,
      isDisplayEnabled,
      isDisplayPartial,
      multipleLimit: 30,
      limit: 10,
      inputWith: 12,
      id: this.$route.params.id,
      customer: {
        id: null,
        name: null,
        abbr: null,
      },
      parentPage: {
        name: '项目管理',
        params: {id: this.$route.params.customerid || ''},
        query: {customername: this.$route.query.customername || ''},
      },

      formRules: formRules,
      fileList: [],
      dataModel: {
        customerid: this.$route.params.customerid || '',
        name: '',
        status: 1,
        number: '',
        budget: 0,
        ticket_predict: '',
        gross_rate_predict: '',
        starttime: '',
        endtime: '',
        detail: '',
        enable_release_notice: '0',
        // 首页任务包：1全部可见 2部分可见 3不展示；新建项目默认全部可见
        app_task_package_display: taskPackageConsts.DISPLAY_ALL,
        app_task_package_title: '',
        app_task_package_whitelist_tags: [],
        type: 1,
        receiver: [],
        bu_approver: 0,
        executive_budget: '',
        attached_file: [],
        predict_frontend_cost: 0,
        predict_label_cost: 0,
        second_approver: null,
        first_approver: null,
        finance_approver: null,
        project_level: '',
        project_category: '',
        target_complete_rate: '',
        target_market_num: '',
        execute_rate: '',
        bd: 0,
        bu: 0,
        review_group: '',
        distribute_type: '',
        predict_backend_cost: 0,
        predict_others_cost: 0,
        is_first_execute: 0,
        business_process_completed: 1,
        annual_cooperation_scale: '',
        annual_cooperation_times: '',
        contract_no: '',
        project_master: '',
      },
      status: 0,
      inLoading: {
        submit: false,
      },
      initiator_name: '',
      activeNames: ['1', '2', '3'],
      distributeType: [],
    }
  },
  created () {
    this.promiseUsers = new Promise((resolve, reject) => {
      this.initiator_name = this.user.name || ''
      let promiseForm = this.setConfig
      if (this.$route.params.id) {
        this.id = this.$route.params.id
        promiseForm = this.setForm
      }
      promiseForm().then((data) => {
        this.setRemoteSelectAdminUsers().then(resolve, reject)
      })
    })

    this.distributeType = this.opts.distributeType.filter(item => { return ![2, 3, 6, 1, 4].includes(item.value * 1) })
  },
  methods: {
    ...Vuex.mapActions(['getPlatformUsersIndex', 'getPlatformUsersDetail', 'getUserTagTable', 'getUserTagDetail']),
    onLoad () {
      this.setCustomer()
    },
    setConfig () {
      return request.common('getProjectDefaultConfig', {}).then(({data}) => {
        this.dataModel.receiver = data.receiver.map((item) => item * 1)
        this.dataModel.first_approver = data.first_approver * 1
        this.dataModel.second_approver = data.second_approver * 1
        this.dataModel.finance_approver = data.finance_approver * 1
      })
    },
    setRemoteSelectAdminUsers () {
      let data = this.dataModel
      let params = [
        data.first_approver, data.second_approver, data.finance_approver, data.bd, data.bu
      ].filter((item) => item !== 0)
      params = params.concat(data.receiver).map((item) => item * 1)
      params = _.uniq(params)
      return request.common('getPlatformUsersIndex', {adminuser_ids: params})
    },
    setPreviousTable (from) {
      if (from.name) {
        this.parentPage = Object.assign({}, from)
      }
    },
    onReload () {
      Object.assign(this.$data, this.$options.data.call(this))
      this.onLoad()
    },
    getRemoteSelectAdminUsers ({id}) {
      return new Promise((resolve, reject) => {
        this.promiseUsers.then(({data}) => {
          if (data) {
            const user = _.find(data.data, {id})
            resolve({
              data: user
            })
          } else {}
        })
      })
    },
    setForm () {
      return request.common('getProjectDetail', {id: this.id}).then(({data}) => {
        filter.setLoop(this.dataModel, data)
        this.initiator_name = data.initiator_name
        this.dataModel.starttime = filter.formatDate(data.starttime * 1000)
        this.dataModel.endtime = filter.formatDate(data.endtime * 1000)
        this.dataModel.type *= 1
        this.dataModel.project_level *= 1
        this.dataModel.app_task_package_display = parseInt(
          data.app_task_package_display || taskPackageConsts.DISPLAY_NONE,
          10
        )
        this.dataModel.app_task_package_title = data.app_task_package_title || ''
        this.dataModel.app_task_package_whitelist_tags = Array.isArray(data.app_task_package_whitelist_tags)
          // remote-select / query_tag 的 id 为字符串，需与 option value 类型一致才能显示 label
          ? data.app_task_package_whitelist_tags.map((id) => String(id))
          : []
        this.status = data.status
        this.fileList = this.dataModel.attached_file
        if (this.$route.name === '复制客户项目信息') {
          this.initiator_name = this.user.name || ''
          this.dataModel.predict_backend_cost = 0
          this.dataModel.predict_others_cost = 0
          this.dataModel.predict_frontend_cost = 0
          this.dataModel.predict_label_cost = 0
          this.dataModel.executive_budget = ''
          this.dataModel.gross_rate_predict = ''
          this.dataModel.ticket_predict = ''
          this.dataModel.status = 1
          this.dataModel.starttime = ''
          this.dataModel.endtime = ''
          this.id = null
          this.setConfig().then((data) => {
            this.setRemoteSelectAdminUsers()
          })
        }
      })
    },
    // 验证结束时间
    endtimeValidator (rule, value, callback) {
      if (Date.parse(this.dataModel.endtime) <= Date.parse(this.dataModel.starttime)) {
        callback(new Error('结束时间必须晚于开始时间'))
      } else {
        callback()
      }
    },
    projectNumberFormatValidator (rule, value, callback) {
      if (this.customer.abbr === value) {
        callback(new Error('客户编号不能仅有客户代码'))
      } else {
        callback()
      }
    },
    appTaskPackageTitleValidator (rule, value, callback) {
      if (isDisplayEnabled(this.dataModel.app_task_package_display) && !(value || '').trim()) {
        callback(new Error('首页任务包名称不能为空'))
      } else {
        callback()
      }
    },
    appTaskPackageWhitelistValidator (rule, value, callback) {
      if (isDisplayPartial(this.dataModel.app_task_package_display) && (!value || !value.length)) {
        callback(new Error('请选择白名单标签'))
      } else {
        callback()
      }
    },
    async onSubmit (isAudited) {
      let isAudit = !!isAudited
      await this.$refs['form'].validate(async (valid) => {
        if (valid) {
          let form = filter.copyJson(this.dataModel)
          // 预算的默认值为0
          form.predict_frontend_cost = Number(form.predict_frontend_cost) || 0
          form.predict_others_cost = Number(form.predict_others_cost) || 0
          form.predict_label_cost = Number(form.predict_label_cost) || 0
          form.predict_backend_cost = Number(form.predict_backend_cost) || 0
          // 收件人追加 bu 和 bd
          form.receiver.push(form.bu)
          form.receiver.push(form.bd)
          form.receiver = _.uniq(form.receiver)
          // isAudit为true保存并提交
          form = {...form, ...{is_audit: isAudit}}
          if (this.dataModel.gross_rate_predict < 0) {
            await this.$confirm('预估毛利率为负数, 是否继续保存?', '提示', {type: 'warning'})
          }
          this.id ? this.update(this.id, form) : this.create(form)
        } else {
          this.$message.error('提交内容填写不正确！')
          this.$nextTick(() => {
            this.scrollToFirstFormError()
          })
        }
      })
    },
    scrollToFirstFormError () {
      const formRef = this.$refs.form
      if (!formRef || !Array.isArray(formRef.fields)) return

      const firstErrorField = formRef.fields.find(f => f && f.validateState === 'error')
      const prop = firstErrorField && firstErrorField.prop

      // 尽量展开包含该字段的折叠面板（当前字段都在折叠里）
      if (prop && Array.isArray(this.activeNames) && this.activeNames.indexOf('1') === -1) {
        // 项目基本信息面板 name="1"
        this.activeNames = Array.from(new Set([...(this.activeNames || []), '1']))
      }

      this.$nextTick(() => {
        // ElementUI: el-form-item 校验失败会加 .is-error
        let el = null
        if (prop) {
          el = this.$el.querySelector(`.el-form-item[prop="${prop}"]`) ||
            this.$el.querySelector(`.el-form-item__content [name="${prop}"]`)
        }
        el = el || this.$el.querySelector('.el-form-item.is-error')
        if (!el) return

        if (typeof el.scrollIntoView === 'function') {
          el.scrollIntoView({behavior: 'smooth', block: 'center'})
        }

        const focusEl = el.querySelector && el.querySelector('input, textarea, [contenteditable="true"]')
        if (focusEl && typeof focusEl.focus === 'function') {
          focusEl.focus()
        }
      })
    },
    create (form) {
      request.common('createCustomerProject', form).then((res) => {
        this.$confirm(this.$route.meta.title + '成功, 是否继续添加？', '提示', {type: 'success'}).then(() => {
          this.$refs.form.resetFields()
          this.dataModel.attached_file = []
          this.fileList = []
        }, this.backToList)
      })
    },
    update (id, form) {
      request.common('updateCustomerProjectBeforeAudit', {id, ...form}).then((res) => {
        this.$confirm(this.$route.meta.title + '成功, 是否前往列表页面？', '提示', {type: 'success'}).then(this.backToList)
      })
    },
    backToList () {
      this.$router.push(this.parentPage)
    },
    isDisabled () {
      // 未指定项目id 时，返回 false
      if (!this.id) {
        return false
      }
      const status = this.status * 1
      const allowStatus = [this.statusEnum.OPEN, this.statusEnum.REJECTED]
      // 超管允许修改 开立、驳回、完成 状态的数据，返回 false
      if (this.user.usertype * 1 === 1) {
        return ![...allowStatus, this.statusEnum.ACHIEVEMENT].includes(status)
      }
      return !allowStatus.includes(status)
    },
    isTicketPredictDisabled () {
      if (!this.id) {
        return false
      }
      const status = this.status * 1
      // 开立状态的项目,允许修改
      if (status === this.statusEnum.OPEN) {
        return false
      }
      // 完成状态的项目,允许超管修改预估开票金额
      if (status === this.statusEnum.ACHIEVEMENT && this.user.usertype * 1 === 1) {
        return false
      }
      // 除上述情况,驳回状态的项目允许进行修改
      return status > this.statusEnum.OPEN && status !== this.statusEnum.REJECTED
    },
    setCustomer () {
      request.common('getCustomerDetail', {id: this.$route.params.customerid}).then(({data}) => {
        this.customer = data
        if (!this.$route.params.id || this.$route.name === '复制客户项目信息') {
          this.dataModel.number = this.customer.abbr
        }
      })
    },
    handleExceed (files, fileList) {
      this.$message.warning(`当前限制选择 10 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
    },
    onChangeFile (file, fileList) {
      let isLt2M = file.raw.size / 1024 / 1024 < 10
      if (!isLt2M) {
        this.$message.error('大小不能超过10MB!')
        this.$refs.upload.uploadFiles.pop()
        return false
      }
      this.onUploadFile(file.raw, fileList)
    },
    onUploadFile (file, fileList) {
      let formData = new FormData()
      formData.append('file', file)
      return request.alert('uploadProjectFile', formData).then(({data}) => {
        this.$message({
          showClose: true,
          message: '上传成功',
          type: 'success',
        })
        let index = this.getFileListIndex(file, fileList)

        let type
        if ((file.name.substr(-5).toLowerCase() === '.jpeg') || (file.name.substr(-4).toLowerCase() === '.jpg') || (file.name.substr(-4).toLowerCase() === '.png')) {
          type = 'pic'
        } else if (file.name.substr(-4).toLowerCase() === '.pdf') {
          type = 'pdf'
        } else if (file.name.substr(-4).toLowerCase() === '.eml') {
          type = 'eml'
        } else if (file.name.substr(-4).toLowerCase() === '.xlsx') {
          type = 'xlsx'
        }
        if (index > -1) {
          this.dataModel.attached_file[index] = {name: file.name, url: data, type: type}
          this.fileList[index] = {name: file.name, url: data, type: type}
        }
      })
    },
    getFileListIndex (file, fileList) {
      for (let i = 0; i < fileList.length; i++) {
        let fileTemp
        if (fileList[i].raw) {
          fileTemp = fileList[i].raw
        } else {
          fileTemp = fileList[i]
        }
        if (file === fileTemp) {
          return i
        }
      }
      return -1
    },
    beforeRemove (file, fileList) {
      let fileTemp
      if (file.raw) {
        fileTemp = file.raw
      } else {
        fileTemp = file
      }
      let index = this.getFileListIndex(fileTemp, fileList)
      if (index > -1) {
        this.dataModel.attached_file.splice(index, 1)
      }
    },
    onGetPdfFile (item) {
      this.$confirm('确认下载文件?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        window.open(item.url)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '下载已取消',
        })
      })
    },
    onViewImage (event) {
      if (event.target.src) {
        this.views = new Viewer(event.target, {
          url: (image) => event.target.src,
        })
      }
      this.views.view()
    },
  },
}

</script>


<style lang="scss"
       scoped>

.view-navbar {
  right: 0px;
  bottom: 0px;
  width: 100%;
  overflow: hidden;
  display: inline;
  float: left;
}
.view-navbar ul {
  transform: translateX(0px);
  transition: all 0.3s;
  box-sizing: content-box;
  overflow: hidden;
  padding: 1px 0;
}
.view-navbar li {
  float: left;
  list-style: none;
  width: 100px;
  height: 100px;
  margin-right: 5px;
  cursor: pointer;
  font-size: 0;
  line-height: 0;
  overflow: hidden;
  transition: opacity 0.15s;
}

/* 首页任务包展示项：label 单行不换行 */
.app-task-package-display-form-item {
  display: flex;
  align-items: center;
  width: unset !important;
  >>> .el-form-item__label {
    width: unset !important;
    white-space: nowrap;
  }
  >>> .el-form-item__content {
    margin-left: 0 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/customer-project/pages/CustomerProjectForm.vue